<p-treeTable
  [columns]="cols"
  [value]="categories && nodes"
  styleClass="p-datatable-sm p-datatable-striped app-table"
  *ngIf="nodes"
  [rowHover]="true"
  [resizableColumns]="true"
  [reorderableColumns]="true"
  [autoLayout]="true"
  sortMode="single"
  [reorderableColumns]="true"
  #tt
>
  <ng-template pTemplate="caption">
    <h3>Categorias</h3>
    <div class="buttons">
      <p-button
        type="button"
        pRipple
        icon="pi pi-plus"
        label="Nova categoria"
        routerLink="new"
        styleClass="p-button-primary mr-2"
        *ngIf="addButton"
      ></p-button>
    </div>
  </ng-template>
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th
        *ngFor="let col of columns"
        [ttSortableColumn]="col.field"
        ttReorderableColumn
        ttResizableColumn
      >
        {{ col.header }}
        <p-treeTableSortIcon [field]="col.field"></p-treeTableSortIcon>
      </th>
    </tr>
    <tr>
      <th *ngFor="let col of columns; let i">
        <input
          pInputText
          type="text"
          (input)="tt.filter($event.target.value, col.field)"
        />
      </th>
    </tr>
  </ng-template>
  <ng-template
    pTemplate="body"
    let-rowNode
    let-rowItem="rowData"
    let-columns="columns"
  >
    <tr [ttRow]="rowNode">
      <td *ngFor="let col of columns; let i = index" [ngClass]="col.styleClass">
        <p-treeTableToggler [rowNode]="rowNode" *ngIf="i === 0" />
        <ng-container
          *ngTemplateOutlet="tableData; context: { col: col, rowItem: rowItem }"
        />
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr style="height: 200px">
      <td [attr.colspan]="cols.length" class="text-center">
        Sem categorias encontradas
      </td>
    </tr>
  </ng-template>
</p-treeTable>

<ng-template #tableData let-col="col" let-rowItem="rowItem">
  <ng-container *ngIf="isRouterLinkAndValid(col, rowItem)">
    <ng-container
      *ngTemplateOutlet="
        routerLinkTemplate;
        context: { col: col, rowItem: rowItem }
      "
    />
  </ng-container>
  <ng-container *ngIf="!isRouterLinkAndValid(col, rowItem)">
    <ng-container
      *ngTemplateOutlet="
        dataDisplayTemplate;
        context: { col: col, rowItem: rowItem }
      "
    />
  </ng-container>
</ng-template>

<ng-template #dataDisplayTemplate let-col="col" let-rowItem="rowItem">
  <ng-container [ngSwitch]="col.type">
    <ng-container *ngSwitchCase="'image'">
      <img [src]="objDisplay(col, rowItem)" />
    </ng-container>
    <ng-container *ngSwitchCase="'formattedInteger'">
      {{ objDisplay(col, rowItem) | number : '1.0-0' }}
    </ng-container>
    <ng-container *ngSwitchCase="'formattedNumber'">
      {{ objDisplay(col, rowItem) | number : '1.0-2' }}
    </ng-container>
    <ng-container *ngSwitchCase="'currency'">
      {{ objDisplay(col, rowItem) | currency : 'BRL' }}
    </ng-container>
    <ng-container *ngSwitchCase="'percentage'">
      {{ objDisplay(col, rowItem) * 100 | number : '1.2-2' }}%
    </ng-container>
    <ng-container *ngSwitchCase="'date'">
      <span
        *ngIf="!col.displayFunction && objValue(col, rowItem)"
        tooltipPosition="bottom"
        [pTooltip]="
          timeDiffLabel(objValue(col, rowItem)).includes('/')
            ? ''
            : timeLabel(objValue(col, rowItem)) || ''
        "
      >
        {{ timeDiffLabel(objValue(col, rowItem)) }}
      </span>
      <ng-container *ngIf="col.displayFunction">
        {{ col.displayFunction(rowItem) }}
      </ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="'inputSwitch'">
      <span *ngIf="!col.canSelect || col.canSelect(rowItem)">
        <label [for]="'inputSwitch_' + col.field" class="input-switch">
          {{ col.switchFalseLabel }}
          <p-inputSwitch
            [ngModel]="objValue(col, rowItem)"
            [trueValue]="trueValue(objValue(col, rowItem))"
            [falseValue]="falseValue(objValue(col, rowItem))"
            (onChange)="inputSwitchChanged($event, rowItem, col)"
            [id]="'inputSwitch_' + col.field"
          />
          {{ col.switchTrueLabel }}
        </label>
      </span>
      <span *ngIf="col.canSelect && !col.canSelect(rowItem)">
        {{ objDisplay(col, rowItem) }}
      </span>
    </ng-container>
    <ng-container *ngSwitchCase="'boolean'">
      <span *ngIf="!col.displayFunction">
        {{ objValue(col, rowItem) ? 'Sim' : 'Não' }}
      </span>
      <span *ngIf="col.displayFunction">
        {{ objDisplay(col, rowItem) }}
      </span>
    </ng-container>
    <ng-container *ngSwitchCase="'button'">
      <ng-container *ngFor="let button of actionButtons">
        <p-button
          *ngIf="button.display(rowItem)"
          [label]="button.label"
          [icon]="button.icon"
          [styleClass]="button.styleClass"
          [pTooltip]="button.tooltip"
          [tooltipPosition]="button.tooltipPosition"
          [rounded]="button.rounded"
          [text]="button.text"
          [severity]="button.severity"
          [size]="button.size"
          (onClick)="actionButtonEvent($event, rowItem, button)"
        />
      </ng-container>
    </ng-container>
    <p-inputNumber
      *ngSwitchCase="'inputNumber'"
      [ngModel]="objValue(col, rowItem)"
      (onBlur)="rowItemChanged.emit(rowItem)"
    />
    <span
      *ngSwitchCase="'status'"
      class="status"
      [class.status--active]="
        col.statusFunction === undefined ||
        col.statusFunction === null ||
        col.statusFunction(rowItem) === 1
      "
      [class.status--progress]="
        col.statusFunction && !col.statusFunction(rowItem)
      "
    >
      {{ objDisplay(col, rowItem) }}
    </span>
    <ng-container *ngSwitchDefault>
      <ng-container *ngIf="!col.innerHTML">
        {{ objDisplay(col, rowItem) }}
      </ng-container>
      <span *ngIf="col.innerHTML" [innerHTML]="col.innerHTML(rowItem)"></span>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #routerLinkTemplate let-col="col" let-rowItem="rowItem">
  <ng-container
    *ngIf="
      linkTarget !== '_action' ||
      !actionFields ||
      !actionFields.includes(col.field)
    "
  >
    <a
      [href]="fullLink(col, rowItem)"
      target="_blank"
      class="data-link"
      *ngIf="fullLink(col, rowItem) && externalLink(fullLink(col, rowItem))"
    >
      <ng-container
        *ngTemplateOutlet="
          dataDisplayTemplate;
          context: { col: col, rowItem: rowItem }
        "
      />
    </a>
    <a
      [routerLink]="fullLink(col, rowItem)"
      [target]="linkTarget === '_action' ? '_self' : linkTarget"
      class="data-link"
      *ngIf="fullLink(col, rowItem) && !externalLink(fullLink(col, rowItem))"
      type="button"
    >
      <ng-container
        *ngTemplateOutlet="
          dataDisplayTemplate;
          context: { col: col, rowItem: rowItem }
        "
      />
    </a>
  </ng-container>
  <a
    *ngIf="
      linkTarget === '_action' &&
      actionFields &&
      actionFields.includes(col.field)
    "
    type="button"
    class="data-link"
    (click)="linkAction.emit({ value: rowItem, field: col.field })"
  >
    <ng-container
      *ngTemplateOutlet="
        dataDisplayTemplate;
        context: { col: col, rowItem: rowItem }
      "
    />
  </a>
</ng-template>
